export default __webpack_public_path__ + "1cd7f4fa9eb5f6ffa556366d8409e27e.svg";